// import Bootstrap
import 'bootstrap';

// import custom JS
import "./misc";